export const savedContentKeys = {
  root: ['saved-content'],
  content: (filters = {}) => [...savedContentKeys.root, 'content', filters],
};
